import { api } from "@/services/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useUpdateUserLives = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationKey: ["update-user-lives"],
    mutationFn: () => api.user.updateLives(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-user"] })
    },
  })

  return mutation
}
